import { useEffect, useState } from "react";
import { Clock, Lock } from "lucide-react";

/**
 * Simple countdown display: Y M D H : M : S
 * Props: target (Date), onExpire?()
 */
export default function Countdown({ target, onExpire, size = "lg" }) {
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => {
      const d = diff(target);
      setT(d);
      if (d.totalMs <= 0) {
        clearInterval(id);
        onExpire && onExpire();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [target, onExpire]);

  const parts = [
    { label: "years", value: t.years },
    { label: "months", value: t.months },
    { label: "days", value: t.days },
    { label: "hours", value: pad(t.hours) },
    { label: "minutes", value: pad(t.minutes) },
    { label: "seconds", value: pad(t.seconds) },
  ];

  const numClass = size === "lg" ? "text-3xl md:text-5xl" : "text-xl";
  const labelClass = size === "lg" ? "text-[10px] md:text-xs" : "text-[9px]";

  return (
    <div className="flex items-center justify-center gap-3 md:gap-5 flex-wrap" data-testid="capsule-countdown">
      {parts.map((p, i) => (
        <div key={p.label} className="flex flex-col items-center min-w-[60px]">
          <div className={`font-serif-elegant text-[#1C1917] tabular-nums ${numClass}`}>{p.value}</div>
          <div className={`uppercase tracking-[0.25em] text-[#4c3f34]/70 ${labelClass}`}>{p.label}</div>
        </div>
      ))}
    </div>
  );
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function diff(target) {
  const now = new Date();
  const t = new Date(target);
  const totalMs = Math.max(0, t.getTime() - now.getTime());
  let ms = totalMs;
  const yearMs = 365.25 * 24 * 3600 * 1000;
  const monthMs = 30.4375 * 24 * 3600 * 1000;
  const years = Math.floor(ms / yearMs); ms -= years * yearMs;
  const months = Math.floor(ms / monthMs); ms -= months * monthMs;
  const days = Math.floor(ms / (24 * 3600 * 1000)); ms -= days * 24 * 3600 * 1000;
  const hours = Math.floor(ms / (3600 * 1000)); ms -= hours * 3600 * 1000;
  const minutes = Math.floor(ms / (60 * 1000)); ms -= minutes * 60 * 1000;
  const seconds = Math.floor(ms / 1000);
  return { years, months, days, hours, minutes, seconds, totalMs };
}
